"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertsContext = void 0;
exports.withAlerts = withAlerts;
const React = __importStar(require("react"));
const defaultSetAlert = (...args) => 
// eslint-disable-next-line no-console
console.info('Setting alert', ...args);
/**
 * To set alerts in Exchange.
 *
 * Sample usage:
 *
 * ```jsx
 * import React from 'react';
 * import { AlertContext } from '@mulesoft/exchange-react-hooks';
 *
 * const MyComponent = () => {
 *   const { setAlert } = React.useContext(AlertContext);
 *
 *   return (
 *     <button onClick={() => setAlert({ type: 'info', message: 'clicked!' })}>Do</button>
 *   );
 * }
 * ```
 *
 * @category Contexts
 */
exports.AlertsContext = React.createContext({
    setAlert: defaultSetAlert
});
exports.AlertsContext.displayName = 'AlertsContext';
/**
 * @ignore
 */
function withAlerts(Component) {
    const AlertsComponent = (props) => {
        return (React.createElement(exports.AlertsContext.Consumer, null, ({ setAlert }) => React.createElement(Component, Object.assign({}, props, { setAlert: setAlert }))));
    };
    AlertsComponent.displayName = `WithAlerts(${Component.displayName || Component.name || 'ComponentName'})`;
    return AlertsComponent;
}
